var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCloseModal = function SvgCloseModal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#D9DDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3891 9.11179L8.61096 16.89M16.3891 16.8899L12.5 13.0008L8.61096 9.11169",
    stroke: "#3D50FC",
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseModal);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iMTIuNSIgZmlsbD0iI0Q5RERGRiIvPgo8cGF0aCBkPSJNMTYuMzg5MSA5LjExMTc5TDguNjEwOTYgMTYuODlNMTYuMzg5MSAxNi44ODk5TDEyLjUgMTMuMDAwOEw4LjYxMDk2IDkuMTExNjkiIHN0cm9rZT0iIzNENTBGQyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";